<template>

   <sdPageHeader>
      <template #title>
      <a-row :gutter="30">
        <a-col>
        <div class="product-single-description">
          <sdHeading class="product-single-title" as="h1" style="margin: 15px">
           Daily Calls Tagged Count Reports
          </sdHeading>
          <span style="margin: 0px; font-size: 16px; font-weight: 400">
          </span>
        </div>
        </a-col>
        </a-row>
        <ProductCard
    class="list-view"
    :style="{ width: '100%', marginBottom: '10px' }"
    >
    <div class="product-list" style="padding: 10px;background-color:#ffffff;">
    
        <!--<BasicFormWrapper>-->
            <a-form
              name="contact"
              :rules="rules"
              :model="formState"
              @submit="handleOk"
              :layout="formState.layout"
            >
            <a-row :gutter="20">
            <!--<a-col :md="5">
              <a-form-item name="center">
                <a-select
                  v-model:value="formState.center"
                  style="width: 100%"
                  showSearch
                >
                <a-select-option
                  v-for="item in branchData"
                  v-bind:key="item.branch_code"
                  :value="item.branch_code"
                >
                  {{ item.branch_code }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="5">
              <a-form-item name="category">
                <a-select
                  v-model:value="formState.category"
                  style="width: 100%"
                  showSearch
                >
                <a-select-option value="SME">SME</a-select-option>
                <a-select-option value="Accounting">Accounting</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>-->
            <a-col :md="6">
              <a-form-item name="organization" label="Domain">
                <a-select
                  v-model:value="formState.organization"
                  style="width: 100%"
                  showSearch
                >
                <a-select-option
                  v-for="item in orgData"
                  v-bind:key="item.organization"
                  :value="item.organization"
                >
                  {{ item.organization }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="5">
            <a-form-item name="condition">
             <a-date-picker
                  style="padding-top: 10px !important"
                  @change="DateSelect"
                  :defaultValue="selectrange"
                />   
            </a-form-item>
            </a-col>
            
            <a-col :md="5">
            <a-form-item>
              <a-button 
                htmlType="submit"
                size="default"
                type="primary"
                key="submit"
                class="btn-add_new"
                style="margin-top: -1.5px !important;"
              >
               <span style="display: inline-flex !important;
              align-items: center !important;">
              <sdFeatherIcons type="arrow-down-circle" size="14" />  &nbsp; 
              Get Report</span>
              </a-button>
             </a-form-item>
              </a-col>
             
              </a-row>
            </a-form>

          <!--</BasicFormWrapper>-->
          
          </div>
          </ProductCard>
      </template>
     
    </sdPageHeader>
     
  <Main>
    <sdCards headless>
    <sdHeading class="product-single-title" as="h3" style="margin: 10px">
    List of Leads
    </sdHeading>
      <template v-if="selectedoption == 'Active'">
      <a-row :gutter="15" style="padding: 10px">
            
            <a-col :xs="24">
              <TopToolBox>
                <div class="product-single-description">
                  <div
                    class="
                      product-single-title
                      page-header-actions
                      product-single-description
                    "
                    style="float: right"
                  >
                    <a-button
                      class="btn-signin"
                      size="small"
                      type="default"
                      v-if="checkselected"
                      @click="bulkIgnore('B')"
                    >
                      <span
                        style="
                          display: inline-flex !important;
                          align-items: center !important;
                        "
                      >
                        <sdFeatherIcons type="x-circle" size="14" /> &nbsp;
                        Dismiss</span
                      >
                    </a-button>
                    
                    <a-button class="btn-signin" size="small" @click="exportToCSV()">
                      <span
                        style="
                          display: inline-flex !important;
                          align-items: center !important;
                        "
                      >
                        <sdFeatherIcons type="download" size="14" /> &nbsp;
                        Export</span
                      >
                    </a-button>
                  </div>
                  <span style="margin: 0px; font-size: 16px; font-weight: 400">
                    <br />
                  </span>
                </div>
              </TopToolBox>
            </a-col>
          </a-row> 
        <a-row :gutter="15">
          <a-col :md="24">
            <TableWrapper class="table-responsive">
              <a-table
                class="ant-table-striped"
                thead-class="greenColor"
                :headers="table_headers"
                :data-source="TableData"
                :columns="TableColumns"
                :row-class-name="
                  (_record, index) => (index % 2 === 1 ? 'table-striped' : null)
                "
                :rowSelection="rowSelection"
                :pagination="{
                  defaultPageSize: 10,
                  total: TableData.length,
                  showTotal: (total, range) =>
                    `${range[0]}-${range[1]} of ${total} items`,
                }"
              >
              </a-table>
            </TableWrapper>
          </a-col>
        </a-row>
      </template>
      
    </sdCards>
  </Main>
</template> 
<script>
import { ContactPageheaderStyle, Action, UserTableStyleWrapper ,ProjectSorting,TopToolBox,} from '../../style';
import { defineComponent } from 'vue';
import { Main, CardToolbox, TableWrapper,BasicFormWrapper } from '../../../styled';
import { dispatch, useStore } from 'vuex';
import { ProductCard } from "./style";
import { defineAsyncComponent, computed, reactive, ref, onMounted, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { message, Notification } from 'ant-design-vue'; 
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
export default defineComponent({
  name: 'CallsTagReport',
  components: {
    Main,
    CardToolbox,
    BasicFormWrapper,
    UserTableStyleWrapper,
    TableWrapper,ProjectSorting,TopToolBox,ProductCard,
  },
  setup() {
    var loading = ref(true);
    var branchData = ref();
    var userData = ref();
    var orgData = ref();
    var checkselected = ref(false);
    var selectcount = ref(null);
    var selectedid = ref(null);
    var selectedoption = ref('Active');
    var selectrange = ref(null);
    const selectedChange = ref(null);
    const { dispatch, state } = useStore();
    const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT; 
    state.FollowData.data = [];
    onMounted(() => {
    getdata();
    getdata1();
    }); 
    const formState = reactive({
      center: "Select Branch",
      category: "Select Team",
      organization: "Corient-UK",
      });
    const rules = {
      center: [
        {
          required: true,
          message: "Please select criteria first",
          trigger: "blur",
        },
      ],
      };
    
    const DateSelect = (date, dateString) => {
      selectrange.value = dateString;
    };
    const handleOk = (values) => {
      dailyData();
    };
    const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
        selectedRowKeys.value = selectedRowKeys;
        selectedRows.value = selectedRows; 
        if (selectedRowKeys.value.length == 0) {
          checkselected.value = false;
        } else {
          checkselected.value = true;
          selectedid = selectedRowKeys.value;
          selectcount.value = selectedRowKeys.value.length + ' Rows Selected';
        }
      },
     
    };
  const getdata = () => {
      loading.value = true;
      dispatch("getAssignFieldsData").then(
        (response) => {
          if (response.status == 200) {
            branchData.value = response.data[0];
            loading.value = false;
          } else {
            loading.value = false;
            //onCancel();
          }
        },
        (error) => {
          console.log(error);
          loading.value = false;
        }
      );
      
    };
    const getdata1 = () => {
      loading.value = true;
      dispatch("manualFieldsData").then(
        (response) => {
          if (response.status == 200) {
            orgData.value = response.data[8];
            loading.value = false;
          } else {
            loading.value = false;
            //onCancel();
          }
        },
        (error) => {
          console.log(error);
          loading.value = false;
        }
      );
      
    };
    const dailyData = () => {
     let startdate = new Date(selectrange.value.toString());
      startdate = startdate.toLocaleDateString("en-CA");
        let api_data = [];
        api_data['center'] = formState.center;
        api_data['category'] = formState.category;
        api_data['startdate'] = startdate;
        api_data['organization'] = formState.organization;

        loading.value = true;
        dispatch("callsTagReport",api_data).then(
        
            (response) => {
                if (response.status == 200) {
                    state.FollowData.data = response.data;
                    Notification["success"]({
                    message: "Succsess!",
                    description: "Leads Loaded.",
                    });
                    loading.value = false;
                } else {
                    loading.value = false;
                    //onCancel();
                }
            },
            (error) => {
                loading.value = false;
                state.FollowData.data = [];
                Notification["error"]({
                message: "Error!",
                description: "Error Loading Leads",
            });
          } 
          
        );
    }
const TableColumns = [
  {
    title: "Date Today",
    dataIndex: "date_today",
    key: "date_today",
    sorter: (a, b) => new Date(a.date_today) - new Date(b.date_today),
    sortDirections: ["descend", "ascend"],
  },
  {
    title: "Day",
    dataIndex: "day",
    key: "day",
  },
  {
    title: "User",
    dataIndex: "user",
    key: "user",
  },
  {
    title: "Email Sent",
    dataIndex: "email_sent",
    key: "email_sent",
  },
  {
    title: "Unique Call",
    dataIndex: "unique_call",
    key: "unique_call",
  },
  {
    title: "Follow-Up",
    dataIndex: "follow_up",
    key: "follow_up",
  },
  {
    title: "Worked on Follow-Up",
    dataIndex: "worked_follow_up",
    key: "worked_follow_up",
  },
  {
    title: "Total Calls",
    dataIndex: "total_calls",
    key: "total_calls",
  },
  {
    title: "Ringing + Voicemail",
    dataIndex: "ringing_voicemail",
    key: "ringing_voicemail",
  },
  {
    title: "GK",
    dataIndex: "gk",
    key: "gk",
  },
  {
    title: "DM",
    dataIndex: "dm",
    key: "dm",
  },
  {
    title: "Dead",
    dataIndex: "dead",
    key: "dead",
  },
  {
    title: "Meeting Schedule",
    dataIndex: "meeting_schedule",
    key: "meeting_schedule",
  },
];
   
let TableData = computed(() =>
state.FollowData.data.map((record) => {
  const {
      date_today,
      day,
      user,
      email_sent,
      unique_call,
      follow_up,
      worked_follow_up,
      total_calls,
      ringing_voicemail,
      gk,
      dm,
      dead,
      meeting_schedule,
            } = record;
            var linedata = [];
  return {
      key: user, // Assuming user or other unique key
      date_today,
      day,
      user,
      email_sent,
      unique_call,
      follow_up,
      worked_follow_up,
      total_calls,
      ringing_voicemail,
      gk,
      dm,
      dead,
      meeting_schedule,
            } 
            
        }
        )
    );

const exportToCSV = () => {
const inputData = state.FollowData.data.map((unreconcile) => {
    const {
      date_today,
      day,
      user,
      email_sent,
      unique_call,
      follow_up,
      worked_follow_up,
      total_calls,
      ringing_voicemail,
      gk,
      dm,
      dead,
      meeting_schedule,
        } = unreconcile;
return {
      "Date":date_today,
      "Day":day,
      "User":user,
      "Email Sent":email_sent,
      "Unique Calls":unique_call,
      "Follow Up":follow_up,
      "Worked on Follow Up":worked_follow_up,
      "Total Calls":total_calls,
      "Ringing/Voicemail":ringing_voicemail,
      "GK":gk,
      "DM":dm,
      "Dead":dead,
      "Meetings Scheduled":meeting_schedule,
      };
      });

      var linedata = [];
      var range = selectrange.value.toString().split(",");
      const fileName ="Daily Calls Tagged Count Report " +range[0];
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";

      const ws = XLSX.utils.json_to_sheet(inputData);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);

      Notification["success"]({
        message: "Success!",
        description: "Downloaded.",
      });
    };
    return {
      loading,
      TableColumns,
      TableData,
      branchData,
      userData,
      rowSelection,
      selectcount,
      checkselected,
      selectedoption,
      handleOk,
      exportToCSV,
      formState,
      selectrange,
      DateSelect,
      rules,
      selectedChange,
      orgData,
     };
  },
});
</script> 
<style scoped>
.ant-table-striped :deep(.table-striped) td th{
  background-color: #447316;
}
th {
  //background-color: #93BF34 !important;
}
.ant-btn-primary {
  background-color: #5C69B3 !important;
  border: 1px solid #5C69B3 !important;
}
.supp-head div{
        width: 250px;
}

.ant-col .ant-select {
  margin-top: 4px;
}
.ant-col button{
  margin-top: 5px;
}
table thead tr th:last-child {
    text-align: left !important;
}
.ant-page-header-heading {
  display: block !important;

}
</style>